import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  contactList: [],
  educatorContactList: [],
  contactDetail: [],
  loading: false,
  error: undefined,
  success: false,
  actionType: null,
};

const contactSlice = createSlice({
  name: "contact",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
      state.loading = false;
      state.success = false;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
      state.actionType = null;
    },
    actionSuccess(state, action) {
      state.success = true;
      state.loading = false;
      state.actionType = action.payload || null;
    },
    fetchContactList(state, action) {
      state.contactList = action.payload;
      state.loading = false;
    },
    fetchEducatorContactList(state, action) {
      state.educatorContactList = action.payload;
      state.loading = false;
    },
    fetchContactDetail(state, action) {
      state.contactDetail = action.payload;
      state.loading = false;
    },
  },
});

export const contactActions = contactSlice.actions;

export default contactSlice.reducer;
